import { ContentBlock } from "@/types";
import { createSecurityServiceContent } from "@/content/services/service-content-helpers";

export const content: ContentBlock[] = [
  ...createSecurityServiceContent({
    serviceName: "fire alarm systems",
    summary:
      "Fire alarm systems need to be reliable, noticeable and suitable for the property. Ozy Wide Group can help with fire alarm installation and servicing support, including reviewing where detection is needed and how alerts should be managed.",
    suitedTo: [
      "homes",
      "shops",
      "offices",
      "warehouses",
      "managed properties",
      "small commercial spaces",
    ],
    includes: [
      "smoke alarm support",
      "fire alarm installation",
      "servicing checks",
      "fault review",
      "integration advice where appropriate",
    ],
    notes: [
      "property type",
      "alarm locations",
      "power and battery condition",
      "occupant routines",
      "maintenance records",
      "compliance responsibilities",
    ],
    process: [
      "Review the property type and the areas where detection needs to be reliable.",
      "Install or service alarms in line with the agreed scope and site requirements.",
      "Explain any follow-up maintenance, faults or replacement needs found during the work.",
    ],
    faq: [
      "Fire alarm requirements can vary by property type and use, so site context matters.",
      "Regular testing and maintenance help identify battery, sensor or alert issues before they become urgent.",
      "If compliance certification is required, confirm the required standard and responsible party before work is booked.",
    ],
  }),
];
